import { render, staticRenderFns } from "./ItemVersions.vue?vue&type=template&id=345d69ae&scoped=true&"
import script from "./ItemVersions.vue?vue&type=script&lang=js&"
export * from "./ItemVersions.vue?vue&type=script&lang=js&"
import style0 from "./ItemVersions.vue?vue&type=style&index=0&id=345d69ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d69ae",
  null
  
)

export default component.exports